import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { Auth0Customer } from "./CustomersData";

export function makeCustomerFields(): FilterField<Auth0Customer>[] {
  const fields: FilterField<Auth0Customer>[] = [
    {
      label: "Name",
      key: "name",
      accessor: (r) => r.name,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Display Name",
      key: "displayname",
      accessor: (r) => r.nameDisplay,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Customer ID",
      key: "customerid",
      accessor: (r) => r.customerId,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Product",
      key: "product",
      accessor: (r) => r.products.map((p) => p.name).join(" "),
      type: "string",
      inFreeText: true,
    },
  ];

  for (const f of fields) f.key ||= labelId(f.label);
  return fields;
}

